import React, { useState, useEffect, useRef } from 'react';
import {
  convertUTCDateToLocalDate,
  FormatDateUsingTimeZone,
} from '../../Utility';

const CommentCard = ({ card }) => {
  const box = useRef(null);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (box.current && !box.current.contains(event.target)) {
        if (
          !event.target.classList.contains('card') &&
          !event.target.classList.contains('card-text') &&
          !event.target.classList.contains('card-body') &&
          !event.target.classList.contains('text-muted')
        ) {
          var element = document.getElementsByClassName('highlight')[0];
          if (element) {
            element.classList.remove('highlight');
            element.classList.add('commented');
          }
        }
        setSelected(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    // Cleanup
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const highlightText = () => {
    var labelArea = document.getElementById(card.referralResultId);

    if (labelArea) {
      var previousHighlight = document.querySelector('.highlight');
      if (previousHighlight) {
        previousHighlight.classList.remove('highlight');
        previousHighlight.classList.add('commented');
      }

      var commentedArea = labelArea.querySelector('.commented');
      if (commentedArea) {
        commentedArea.classList.add('highlight');
        commentedArea.classList.remove('commented');
      }
    }
    setSelected(true);
  };

  return (
    <div
      ref={box}
      className={`card border border-phcn mb-3 ${
        card.comment === '' ? 'd-none' : ''
      } ${selected ? 'selected' : ''}`}
      onClick={highlightText}
      data-testid='comment-card'
    >
      <div className='card-body'>
        <p style={{ fontWeight: 'bold' }}>
          Reference Text: <span>{card.highlightedText}</span>
        </p>
        <p className='card-text'>{card.comment}</p>
        <div>
          <span>
            <small className='text-muted'>{card.userName}</small>
          </span>
          <p className='card-text'>
            <small className='text-muted'>
              Posted On:{' '}
              {FormatDateUsingTimeZone(
                convertUTCDateToLocalDate(card.createdOn)
              )}
            </small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CommentCard;
